import { useState } from "react";
import { addDays } from "../utils/dateUtils";

export function useAddInvoice() {
  const today = new Date().toISOString().split("T")[0];

  const initialState = {
    filial: 0,
    nombre_propietario: "",
    fecha_emision: today,
    fecha_vencimiento: addDays(today, 5),
    concepto: "", // se llenará automáticamente con el nombre del rubro
    monto: 0,
    rubro: null,           // ID de CuentaContable INGRESO (antes era Rubro)
    medida_anterior: "",
    medida_actual: "",
    cuenta_ingreso: null,  // mismo que rubro — enviado al backend para asiento automático
    // ── Moneda ──────────────────────────────────────────────────────────
    moneda: "CRC",
    tipo_cambio: 1,
  };

  const [invoiceData, setInvoiceData] = useState(initialState);
  const [errors, setErrors] = useState({});

  function updateField(field, value) {
    setInvoiceData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => {
        const e = { ...prev };
        delete e[field];
        return e;
      });
    }
  }

  function resetFields() {
    setInvoiceData(initialState);
    setErrors({});
  }

  function validate(isAgua = false) {
    const e = {};

    if (!invoiceData.filial || invoiceData.filial === 0)
      e.filial = "Seleccioná una filial.";

    if (!invoiceData.rubro) e.rubro = "Seleccioná un rubro.";

    if (!invoiceData.fecha_emision)
      e.fecha_emision = "La fecha de emisión es obligatoria.";

    if (!invoiceData.fecha_vencimiento)
      e.fecha_vencimiento = "La fecha de vencimiento es obligatoria.";

    if (
      invoiceData.fecha_emision &&
      invoiceData.fecha_vencimiento &&
      invoiceData.fecha_vencimiento < invoiceData.fecha_emision
    )
      e.fecha_vencimiento =
        "La fecha de vencimiento no puede ser anterior a la de emisión.";

    if (!invoiceData.monto || Number(invoiceData.monto) <= 0)
      e.monto = "El monto debe ser mayor a 0.";

    if (isAgua) {
      if (
        invoiceData.medida_anterior === "" ||
        invoiceData.medida_anterior === null
      )
        e.medida_anterior =
          "La medida anterior es obligatoria para rubro agua.";
      else if (Number(invoiceData.medida_anterior) < 0)
        e.medida_anterior = "La medida no puede ser negativa.";

      if (
        invoiceData.medida_actual === "" ||
        invoiceData.medida_actual === null
      )
        e.medida_actual = "La medida actual es obligatoria para rubro agua.";
      else if (Number(invoiceData.medida_actual) < 0)
        e.medida_actual = "La medida no puede ser negativa.";

      if (
        invoiceData.medida_anterior !== "" &&
        invoiceData.medida_actual !== "" &&
        Number(invoiceData.medida_actual) < Number(invoiceData.medida_anterior)
      )
        e.medida_actual = `La medida actual (${invoiceData.medida_actual}) no puede ser menor que la anterior (${invoiceData.medida_anterior}).`;
    }

    setErrors(e);
    return Object.keys(e).length === 0;
  }

  function clearErrors() {
    setErrors({});
  }

  return {
    invoiceData,
    updateField,
    resetFields,
    errors,
    validate,
    clearErrors,
  };
}
